module.exports = __webpack_public_path__ + "assets/img/happy-customers-2000.a04e2488.svg";